import React from 'react'
import PropTypes from 'prop-types'
import {Button, Text} from '@chakra-ui/react'
import {SearchIcon} from '../../icons'
import StyledContent from '../../../leap/components/styled-content'

const Suggestion = ({suggestion, closeAndNavigate, searchBarPosition}) => (
    <Button
        width="full"
        height="full"
        onMouseDown={() =>
            closeAndNavigate(suggestion.link, {
                search_bar_position: searchBarPosition,
                flyout_section: 'Phrases',
                flyout_selection: suggestion.name
            })
        }
        fontSize={'md'}
        marginTop={0}
        variant="menu-link"
        padding={0}
        maxWidth="auto"
        whiteSpace="normal"
        textAlign="left"
        leftIcon={<SearchIcon boxSize={4} color="stokkeGray.dark" />}
    >
        <StyledContent as={Text} content={suggestion.name} />
    </Button>
)

Suggestion.propTypes = {
    suggestion: PropTypes.object.isRequired,
    closeAndNavigate: PropTypes.func,
    searchBarPosition: PropTypes.string
}

export default Suggestion
